import request from '@/utils/request';
import { apiServiceV1, dataServiceV1, appServiceV1 } from '@/config/apiPrefix.config';

// 获取用户购买的服务类型
export const getBuyService = (data) => request(`${apiServiceV1}/service/get_user_app_service`, {
  params: data,
});

// 获取用户已经购买的服务
export const getMyServiceData = (data) => request(`${apiServiceV1}/service/get_my_service`, {
  params: data,
});

// 获取用户已经购买的服务
export const getUsingServiceData = () => request(`${apiServiceV1}/service/get_service_list_card`);

// 获取服务的超额配置
export const getAppServiceConfig = (data) => request(`${apiServiceV1}/config/get_user_app_service_config`, {
  params: data,
});

// 设置服务的超额配置
export const setAppServiceConfig = (data) => request(`${apiServiceV1}/config/app_service_config`, {
  body: data,
  method: 'post',
});

// 获取所有服务
export const getAppList = (data) => request(`${appServiceV1}/list`, {
  params: data,
});

// 获取服务调用记录
export const getServiceLog = (data) => request(`${dataServiceV1}/apilog/call_history`, {
  body: data,
  method: 'post',
});

// 获取用户ID的已经购买的服务
export const getMyServiceDataByUserId = (data) => request(`${apiServiceV1}/service/get_customer_service`, {
  params: data,
});